import Content from "../../common/Content";
import Button from "../../ui/Button";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrow-right.svg";
import DifficultySelector from "../../ui/DifficultySelector";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import GameArea from "../../ui/GameArea";
import PlayButton from "../../ui/PlayButton";
import FingerSkillsLevel from "../FingerSkills/FingerSkillsLevel";
import ContentCenter from "../../ui/ContentCenter";
import ArmsUpLevel from "./ArmsUpLevel";

export const ArmsUpIntroBanner = ({ full = false }) => {
  return (
    <ContentCenter style={full ? { height: "100%" } : {}}>
      <img src={"/armsup/card-1.png"} height={240} />
    </ContentCenter>
  );
};

const GESTURE_COUNT = 34;

export default ({ onSetLevel, game }: any) => {
  const { t } = useTranslation("games");
  const [level, setLevel] = useState(1);
  const [started, setStarted] = useState(false);

  const gestures = Array.from(Array(GESTURE_COUNT)).map(
    (i, index) => index + 1
  );

  useEffect(() => {
    setStarted(false);
  }, [level]);

  const startGame = () => {
    setStarted(true);
  };

  return (
    <>
      <GameArea game={game}>
        {started ? <ArmsUpLevel /> : <ArmsUpIntroBanner full />}
      </GameArea>

      <Content>
        <div>{started ? <></> : <PlayButton onClick={startGame} />}</div>
        <DifficultySelector
          switchDifficulty={(level) => {
            onSetLevel(level);
            setLevel(level);
          }}
          levels={3}
          current={level}
        />
      </Content>
    </>
  );
};
